<p-dialog [(visible)]="showDialog" styleClass="quick-view-grid-row odrReport-dialog" header={{header}}
  [style]="{width: '30vW', minWidth: '450px'}" appendTo="body" showEffect="fade" [modal]="true"
  (onHide)="onclose()">
    @if(isOdrReportLoadingResults){
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>
    }
  <form [formGroup]="reportForm">
    <div class="form-panel">
      <div class="row">
        <div class="col-12">
          <div class="row mb-2 field-type-wrapper">
            <div class="col-12 col-md-4">
              <label for="type">Report Type<span class="required-asterisk">*</span>
              </label>
            </div>
            <div class="col-12 col-md-8">
              <p-select appendTo="body" required name="type" id="type" [options]="typeOptions" formControlName="type"
               [style]="{ 'text-transform': 'capitalize', 'width':'70%'}"
                placeholder="Select type">
              </p-select>
              <small class="error-message">{{getErrorMessage('type')}}</small>
            </div>
          </div>

          @if(reportForm.get('type')?.value == '606(A1)'){
          <div class="row field-wrapper">
            <div class="col-12 col-md-4">
              <label for="type">Reporting Year<span class="required-asterisk">*</span>
              </label>
            </div>
            <div class="col-12 col-md-8">
              <input pInputText placeholder="YYYY" id="reportingYear" formControlName="reportingYear"
                [style]="{ 'text-transform': 'capitalize', 'width':'70%'}" maxlength="4" />
                <small class="error-message">{{getErrorMessage('reportingYear')}}</small>
            </div>
          </div>

          <div class="row field-wrapper">
            <div class="col-12 col-md-4">
              <label for="type">Reporting Quarter<span class="required-asterisk">*</span>
              </label>
            </div>
            <div class="col-12 col-md-8">
              <p-select appendTo="body" name="quarter" id="quarter" [options]="reportingQuarter"
                formControlName="quarter" [style]="{ 'text-transform': 'capitalize', 'width':'70%'}"
                placeholder="Select quarter">
              </p-select>
                <small class="error-message">{{getErrorMessage('quarter')}}</small>
            </div>
          </div>
          }
          @if(reportForm.get('type')?.value == '606(B1)' || reportForm.get('type')?.value == '606(B3)'){
          <div class="row field-wrapper">
            <div class="col-12 col-md-4">
              <label for="type">Reporting Start Date<span class="required-asterisk">*</span>
              </label>
            </div>
            <div class="col-12 col-md-8">
              <p-datepicker inputId="startDate" id="startDate" [touchUI]="true" appendTo="body" formControlName="startDate"
                dateFormat="yy-mm-dd" placeholder="YYYY-MM-DD" [readonlyInput]="false" styleClass="CalendarformfieldSize"
                [motionOptions]="{ duration: 0 }">
              </p-datepicker>
               <small class="error-message">{{getErrorMessage('startDate')}}</small>
                @if(reportForm.errors?.['dateRangeInvalid'] && 
                  (reportForm.get('startDate')?.touched || reportForm.get('endDate')?.touched)){
                <small class="error-message"> Start date cannot be greater than end date
                </small>
                }
            </div>
          </div>
          <div class="row field-wrapper">
            <div class="col-12 col-md-4">
              <label for="type">Reporting End Date<span class="required-asterisk">*</span>
              </label>
            </div>
            <div class="col-12 col-md-8">
              <p-datepicker inputId="endDate" id="endDate" [touchUI]="true" appendTo="body" formControlName="endDate"
                dateFormat="yy-mm-dd" placeholder="YYYY-MM-DD" [readonlyInput]="false" styleClass="CalendarformfieldSize" [motionOptions]="{ duration: 0 }">
              </p-datepicker>
               <small class="error-message">{{getErrorMessage('endDate')}}</small>
            </div>
          </div>
            <div class="row field-wrapper">
              <div class="col-12 col-md-4">
                <label for="type">Customer<span class="required-asterisk">*</span>
                </label>
              </div>
              <div class="col-12 col-md-8">
                <p-select #custSelect appendTo="body" name="customerName" id="customerName" [options]="customerList"
                  formControlName="customerName" [style]="{ 'text-transform': 'capitalize', 'width':'70%'}"
                  placeholder="Select or enter customer name" filter="true" [editable]="true"
                  (onFocus)="custSelect.show()">
                </p-select>
                <small class="error-message">{{getErrorMessage('customerName')}}</small>
              </div>
            </div>
          }
          @if(reportForm.get('type')?.value == '606 Interchange'){
          <div class="row field-wrapper">
            <div class="col-12 col-md-4">
              <label for="type">Reporting Start Date<span class="required-asterisk">*</span>
              </label>
            </div>
            <div class="col-12 col-md-8">
              <p-datepicker inputId="startDate" id="startDate" [touchUI]="true" appendTo="body" formControlName="startDate"
                dateFormat="yy-mm-dd" placeholder="YYYY-MM-DD" [readonlyInput]="false" styleClass="CalendarformfieldSize" [motionOptions]="{ duration: 0 }">
              </p-datepicker>
               <small class="error-message">{{getErrorMessage('startDate')}}</small>
               @if(reportForm.errors?.['dateRangeInvalid'] &&
                  (reportForm.get('startDate')?.touched || reportForm.get('endDate')?.touched)){
                <small class="error-message"> Start date cannot be greater than end date
                </small>
                }
            </div>
          </div>
          <div class="row field-wrapper">
            <div class="col-12 col-md-4">
              <label for="type">Reporting End Date<span class="required-asterisk">*</span>
              </label>
            </div>
            <div class="col-12 col-md-8">
              <p-datepicker inputId="endDate" id="endDate" [touchUI]="true" appendTo="body" formControlName="endDate"
                dateFormat="yy-mm-dd" placeholder="YYYY-MM-DD" [readonlyInput]="false" styleClass="CalendarformfieldSize" [motionOptions]="{ duration: 0 }">
              </p-datepicker>
               <small class="error-message">{{getErrorMessage('endDate')}}</small>
            </div>
          </div>
            <div class="row field-wrapper">
              <div class="col-12 col-md-4">
                <label for="type">Sender IMID<span class="required-asterisk">*</span>
                </label>
              </div>
              <div class="col-12 col-md-8">
                <p-select #senderSelect appendTo="body" name="senderImid" id="senderImid" [options]="senderImidList"
                  formControlName="senderImid" [style]="{ 'text-transform': 'capitalize', 'width':'70%'}"
                  placeholder="Select or enter sender IMID" filter="true" [editable]="true"
                  (onFocus)="senderSelect.show()">
                </p-select>
                <small class="error-message">{{getErrorMessage('senderImid')}}</small>
              </div>
            </div>
            <div class="row field-wrapper">
              <div class="col-12 col-md-4">
                <label for="useComplianceId">Use ComplianceID
                </label>
              </div>
              <div class="col-12 col-md-8">
                <p-select appendTo="body" name="useComplianceId" id="useComplianceId" [options]="useComplianceIdOptions"
                  formControlName="useComplianceId" [style]="{ 'text-transform': 'capitalize', 'width':'70%'}"
                  placeholder="Select">
                </p-select>
              </div>
            </div>
          }
        </div>

      </div>
    </div>
    <div class="mt-3 btn-panel">
      <div class="col-12 text-end">
        <p-button id="close" type="button" icon="fa fa-close" (click)="onclose()" class="odr-footer-button" label="Close"></p-button>
        <p-button id="save" type="submit" icon="fa fa-check" class="odr-footer-button" 
        [disabled]="isSubmitButtonDisabled" (click)="onSubmit()" label="Submit">
        </p-button>
      </div>
    </div>
  </form>
</p-dialog>
<p-dialog appendTo="body" header="Add Comment" [style]="{ width: getResolutionWidth() }" [(visible)]="isDisplayCommentViewer"
  [modal]="true" (onHide)="onclose()" [scrollTop]="true">
    @if(isOdrReportLoadingResults){
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>
    }
  <div>
      <!-- Filter Code -->
      <div class="col-lg-12 nopadding">
        <mat-chip-listbox aria-label="filter" class="mb-5">
            @if(commentStaticFilters.reportName){
            <mat-chip selected [id]="commentStaticFilters.reportName">
              Report Name: {{commentStaticFilters.reportName}}
            </mat-chip>
            }
            @if(commentStaticFilters.reportStatus){
            <mat-chip selected [id]="commentStaticFilters.reportStatus">
              Report Status: {{commentStaticFilters.reportStatus}}
            </mat-chip>
            }
            @if(commentStaticFilters.reportingQuarter){
            <mat-chip selected [id]="commentStaticFilters.reportingQuarter">
              Quarter: {{commentStaticFilters.reportingQuarter}}
            </mat-chip>
            }
            @if(commentStaticFilters.reportingYear){
            <mat-chip selected [id]="commentStaticFilters.reportingYear">
              Year: {{commentStaticFilters.reportingYear}}
            </mat-chip>
            }
             @if(commentStaticFilters.reportingStartDate){
           <mat-chip selected [id]="commentStaticFilters.reportingStartDate">
              StartDate: {{commentStaticFilters.reportingStartDate}}
            </mat-chip>
          }
           @if(commentStaticFilters.reportingEndDate){
            <mat-chip [id]="commentStaticFilters.reportingEndDate">
              EndDate: {{commentStaticFilters.reportingEndDate}}
            </mat-chip>
          }
            
        </mat-chip-listbox>
      </div>
  </div>
  
  <!-- Add Comment Box -->
  @if(isDisplayCommentViewer) {
    <div class="mb-5">
      <form name="addCommentForm" #ProcessFlow="ngForm" novalidate>
        <div class="ui-grid ui-grid-responsive">
          <div class="ui-grid-col-1">
            <label for="comment">Comment <span class="required-asterisk">*</span></label>
          </div>
          <div class="ui-grid-col-10">
            <textarea pInputTextarea [required]="true" [maxLength]="maxCharsLength" [(ngModel)]="commentStatement" class="width-100"
              name="userComment" id="userComment" #userComment="ngModel"></textarea>
              @if(userComment.invalid && (userComment.dirty || userComment.touched)){
                 <small class="comment-error-message">Comment Is Required</small>
              }
          </div>
        </div>
        <div class="ui-grid ui-grid-responsive">
          <div class="text-right ui-grid-col-11">
            <span class="charsCounter"> Characters Remaining: 
              {{((commentStatement && commentStatement.length > 0) ? (maxCharsLength-commentStatement.length) : maxCharsLength)}}</span>
          </div>
        </div>
      </form>
    </div>
  }
  <!-- End of Adding Comment Box -->
    <ng-template #footer>
      <button pButton type="button" id="catalyst-comment-close" icon="fa fa-close" (click)="onclose()" label="Close" class="ui-button-secondary userActionBtn" style="background: #e54a23;"></button>
      <button pButton type="button" id="AddComment" label="Submit"
      icon="fa fa-check" class="ui-button-info btn-style" (click)="insertComment();"></button>
      </ng-template>
</p-dialog>